import styled from '@emotion/styled';
import { VariableSizeList } from 'react-window';

export const WorklogsList = styled.div`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  flex: 1 1 auto;
  padding: 0;
  margin: 0;
  height: ${({ height }) => (height ? `${height}px` : '100%')};
`;

export const WorklogsListStory = styled.div`
  margin-top: 10px;
  padding: 0 12px;
  flex: 1 0 50%;
  display: flex;
  flex-direction: column;
  height: 400px;
`;

export const List = styled(VariableSizeList)`
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0);

  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  ::-webkit-scrollbar-button:end:increment,
  ::-webkit-scrollbar-button:start:decrement {
    background: #0000;
    display: none;
  }

  ::-webkit-scrollbar-track-piece {
    background: ${({ theme }) =>
      theme.name === 'dark' ? '#1b2015' : '#091e4214'};
  }

  ::-webkit-scrollbar-track-piece:vertical:start {
    border-radius: 4px 4px 0 0;
  }

  ::-webkit-scrollbar-track-piece:vertical:end {
    border-radius: 0 0 4px 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:start {
    border-radius: 4px 0 0 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:end {
    border-radius: 0 4px 4px 0;
  }

  ::-webkit-scrollbar-thumb:horizontal,
  ::-webkit-scrollbar-thumb:vertical {
    background: ${({ theme }) =>
      theme.name === 'dark' ? '#313b36' : '#091e4221'};
    border-radius: 4px;
    display: block;
    height: 48px;
  }
`;
